import Request from './request';

/**
 * @description: user login api
 */

export const getSurveys = async (eventid, params = {}) => {
  return await Request.get('/v1/events/'+eventid+'/surveys', params).then((res) => {
    return res;
  });
};

export const getSurvey = async (id) => {
  return await Request.get('/v1/surveys/'+id, {}).then((res) => {
    return res;
  });
};

export const getQuestions = async (surveyid, params = {}) => {
  const requestParams = {
    ...params,
    sort: {
      'ranking' : -1,
      // 'id'      : 1,
    },
    pagination: {
      'start' : 0,
      'limit' : 100,
    }
  };
  return await Request.get('/v1/surveys/'+surveyid+'/questions', requestParams).then((res) => {
    return res;
  });
};

export const postAnswer = async (surveyid, questionid, params) => {
  console.log('params:',params);
  if(params.type == 'file'){
    return await Request.fileformpost('/v1/surveys/'+surveyid+'/responses/me/answers/'+questionid, 'answer', params.answer, params).then((res) => {
      return res;
  });
  }else{
    return await Request.formpost('/v1/surveys/'+surveyid+'/responses/me/answers/'+questionid, params).then((res) => {
      console.log('res',res);
      return res;
  });
  }
};

export const postSurveySubmit = async (id, params) => {
  return await Request.formpost('/v1/surveys/'+id+'/responses/me/submit', params).then((res) => {
    return res;
  });
};

export const getSurveyResponses = async (surveyid, uid) => {
  let params = {};
  params.start = 0;
  params.num   = 100;
  params.filter = {
    'uid' : uid
  }
  params.sort  = {
    'id' : 'DESC'
  };
  console.log('response:',params);
  return await Request.get('/v1/surveys/'+surveyid+'/responses', params).then((res) => {
    return res;
  });
}

export const getSurveyResponse = async (surveyid, responseid) => {
  return await Request.get('/v1/surveys/'+surveyid+'/responses/'+responseid, {}).then((res) => {
    return res;
  });
}